import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { FC, ReactElement, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface ContextMenuProps {
  options: { key?: string; label: string; onClick?: () => void; icon?: ReactElement; closeOnClick?: boolean }[];
}

const ContextMenu: FC<ContextMenuProps> = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuIconClick = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: "inline" }}>
      <IconButton onClick={handleMenuIconClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu open={Boolean(anchorEl)} onClose={handleClose} anchorEl={anchorEl ? anchorEl : document.body}>
        {options.map((option) => (
          <MenuItem
            key={option.key ?? option.label}
            onClick={() => {
              option.onClick?.();
              if (option.closeOnClick !== false) {
                handleClose();
              }
            }}>
            {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default ContextMenu;
